export default "__VITE_ASSET__51dfe0be__"